/**
 * The list page's search rule, on its own so it can be tested and so the
 * placeholder and empty-state copy can promise exactly what it does.
 *
 * Searches the tag, the kind and the summary. The summary is what makes
 * "posts" or "last 2 days" findable: the mode and window live in the
 * row's params, not its tag.
 */
export function matchesSearch(
    row: { tag: string; kind: string; summary: string },
    needle: string
): boolean {
    const wanted = needle.trim().toLowerCase()
    if (!wanted) return true
    return `${row.tag} ${row.kind} ${row.summary}`.toLowerCase().includes(wanted)
}
